import { environment, cookie } from '@gaodun.com/gtools';

// 国际化HTTP配置接口
export interface I18nHttpConfig {
    // 国际化API网关地址
    i18nBaseURL?: string;
    // 国际化请求头配置
    i18nHeaders?: Record<string, string>;
    // 国际化登出处理函数（只处理登出，不关心状态码）
    i18nLogoutHandler?: () => void;
    // 国际化错误消息配置
    i18nErrorMessages?: {
        serverError?: string;
        loginRequired?: string;
    };
}

// 默认配置
const defaultI18nHttpConfig: I18nHttpConfig = {
    i18nBaseURL: `https://${environment.getApiEnv()}apigateway.areteup.com`,
    i18nHeaders: {
        'Accept-Language': 'en',
    },
    i18nErrorMessages: {
        serverError: 'Server error',
        loginRequired: 'Please login',
    },
    i18nLogoutHandler: () => {
        // 默认登出处理
        location.href = `https://${environment.getApiEnv()}www.areteup.com/login`;
    },
};

// 配置管理器
class I18nHttpConfigManager {
    private config: I18nHttpConfig = { ...defaultI18nHttpConfig };

    getI18nBaseURL(): string {
        return this.config.i18nBaseURL || defaultI18nHttpConfig.i18nBaseURL!;
    }

    getI18nToken(): string {
        return cookie.getCookie('Accesstoken');
    }

    getI18nHeaders(): Record<string, string> {
        const headers = { ...defaultI18nHttpConfig.i18nHeaders, ...this.config.i18nHeaders };
        return headers;
    }

    getErrorMessage(key: 'serverError' | 'loginRequired'): string {
        const custom = this.config.i18nErrorMessages;
        if (custom && custom[key]) return custom[key] as string;
        return defaultI18nHttpConfig.i18nErrorMessages![key]!;
    }

    // 只处理登出，不关心状态码
    handleI18nLogout(): void {
        if (this.config.i18nLogoutHandler) {
            this.config.i18nLogoutHandler();
        } else if (defaultI18nHttpConfig.i18nLogoutHandler) {
            defaultI18nHttpConfig.i18nLogoutHandler();
        }
    }
}

// 单例导出
export const i18nHttpConfigManager = new I18nHttpConfigManager();
